// eslint-disable-next-line max-len
export const extractUpcomingStartTime = viewable => (viewable.defaultPlayable?.broadcast?.start || 0) * 1000;
